import { render, staticRenderFns } from "./ProductAdvanced.vue?vue&type=template&id=0b807edc&scoped=true"
import script from "./ProductAdvanced.vue?vue&type=script&lang=js"
export * from "./ProductAdvanced.vue?vue&type=script&lang=js"
import style0 from "./ProductAdvanced.vue?vue&type=style&index=0&id=0b807edc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b807edc",
  null
  
)

export default component.exports